import React from 'react';

import { createStyles } from '../tss';

const useStyles = createStyles(() => ({
  root: {
    transition: 'height 300ms ease',
    position: 'relative',
    overflow: 'hidden',
  },
  container: {
    position: 'absolute',
  },
}));

interface Props {
  children: React.ReactNode;
  className?: string;
  classes?: Partial<ReturnType<typeof useStyles>['classes']>;
  open: boolean;
  unmountOnExit?: boolean;
}

export const VerticalCollapse: React.FC<Props> = ({
  children,
  classes: classesOverrides,
  className,
  open,
  unmountOnExit,
}) => {
  const { classes, cx } = useStyles({ classesOverrides });
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = React.useState(0);

  React.useEffect(() => {
    setHeight(containerRef.current?.scrollHeight || 0);
  }, []);

  return (
    <div className={cx(classes.root, className)} style={{ height: open ? height : 0 }}>
      <div className={classes.container} ref={containerRef} style={{ maxHeight: height }}>
        {(open || !unmountOnExit) && children}
      </div>
    </div>
  );
};
